import { CentralPageContainer } from "./styles";
import { useHistory } from "react-router-dom";
import { ServicesCard } from "views/components/ServicesCard";
import { getNameInitials } from "lib/helpers/getNameInitials";
import { pathOr } from "ramda";
import { setGlobal } from "reactn";
import { sites } from "./data";
import { useGlobal } from "reactn";
import React, { useEffect } from "react";
import logo from "views/resources/logos/SVG/zeroqBlueFull.svg";
export const CentralPage = () => {
	const history = useHistory();
	const [user] = useGlobal("user");
	const name = pathOr("", ["name"], user);

	useEffect(() => {
		if (!name) {
			setGlobal({ UIConfig: { hideFooter: false, hideHeader: false } });
			history.push("/");
			return;
		}
		setGlobal({ UIConfig: { hideFooter: true, hideHeader: true } });
	}, []);

	const handleRedirect = () => {
		setGlobal({ UIConfig: { hideFooter: false, hideHeader: false } });
		history.push("/");
	};

	return (
		<CentralPageContainer>
			<div className="header">
				<button onClick={handleRedirect}>
					<img src={logo} alt="ZeroQ Logo" />
				</button>
				<div className="header__user-info">
					<div className="header__user-image">
						{getNameInitials(name)}
					</div>
					{name}
				</div>
			</div>
			<div>
				<h3>
					Plataforma de <span>accesos a ZeroQ </span>
				</h3>
				<p>Ingresa a todos los paneles de nuestro ecosistema</p>
			</div>
			<div className="cards-grid">
				{sites.map((info) => (
					<ServicesCard key={info.id} {...info} />
				))}
			</div>
		</CentralPageContainer>
	);
};

export default CentralPage;
